var map = {
	"./": 458,
	"./development": 1416,
	"./development.js": 1416,
	"./index": 458,
	"./index.js": 458,
	"./preprod": 1417,
	"./preprod.js": 1417,
	"./production": 1398,
	"./production.js": 1398,
	"./staging": 1418,
	"./staging.js": 1418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3389;